import * as React from 'react';
import { CopyableText, DataDisplayTable } from '@css-xp/base';
import { useTransactionAccountContext } from '@css-xp/base/common-context';

interface Props {
  label: string;
}

const TransactionAccountDetailsTab = (_props: Props) => {
  const { data, loading, error, getTransactionAccount } = useTransactionAccountContext();

  const transactionAccount = getTransactionAccount(data);
  return (
    <div className="transaction-account-details-tab" data-testid="transaction-account-details-tab">
      <h2>Account details</h2>
      <DataDisplayTable isLoading={loading} error={error?.message} id="transaction-account-details">
        <tbody>
          <tr>
            <td>Billing account ID</td>
            <td>
              <CopyableText text={transactionAccount?.transactionAccountNumber} />
            </td>
          </tr>
          <tr>
            <td>Billing account UUID</td>
            <td>
              <CopyableText text={transactionAccount?.id} />
            </td>
          </tr>
        </tbody>
      </DataDisplayTable>
    </div>
  );
};

export default TransactionAccountDetailsTab;
